import { render, staticRenderFns } from "./MockSectionsLabel.vue?vue&type=template&id=b08b7300&"
import script from "./MockSectionsLabel.vue?vue&type=script&lang=js&"
export * from "./MockSectionsLabel.vue?vue&type=script&lang=js&"
import style0 from "./MockSectionsLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports